module.exports = __webpack_public_path__ + "img/705870d.jpg";